import React from 'react';
import { HoverCard } from './types';

interface HoverCardProps {
  hoverCard: HoverCard;
  onLocationClick?: (location: any) => void;
  onHide: () => void;
}

export const MapHoverCard: React.FC<HoverCardProps> = ({
  hoverCard,
  onLocationClick,
  onHide
}) => {
  return (
    <div
      className="fixed z-50 pointer-events-none"
      style={{
        left: hoverCard.x - 130,
        top: hoverCard.y - 160,
        maxWidth: '260px'
      }}
    >
      <div className="bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden animate-in fade-in duration-150">
        <div className="h-20 bg-gray-200 overflow-hidden">
          {hoverCard.location.images && hoverCard.location.images.length > 0 ? (
            <img
              src={hoverCard.location.images[0]}
              alt={hoverCard.location.name}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center">
              <span className="text-gray-400 text-xs">Няма фота</span>
            </div>
          )}
        </div>

        <div className="p-3">
          <h3 className="font-bold text-gray-900 text-sm mb-2 line-clamp-1 leading-tight">
            {hoverCard.location.name}
          </h3>

          <button
            onClick={() => {
              if (onLocationClick) {
                onLocationClick(hoverCard.location);
              }
              onHide();
            }}
            className="w-full bg-primary text-white py-1.5 px-3 rounded-lg font-medium hover:bg-primary/90 transition-colors text-xs pointer-events-auto"
          >
            Падрабязней
          </button>
        </div>
      </div>
    </div>
  );
};